export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10087.fa2e19ef.jpg";